import React from "react";
import { useRegistrarAcordoContext } from "..";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";

export default function IndicadoresDeValor() {
    const { indicadores } = useRegistrarAcordoContext();

    return indicadores ? (
        <div className="card card-custom">
            <div className="row no-gutters">
                <div className="text-center p-3 col-12 col-sm-6 col-md-4 col-lg-2">
                    <span>Valor do Contrato</span>
                    <strong className="w-100 d-block font-size-lg">
                        {formatMoneyReais(indicadores.VL_CONTRATO)}
                    </strong>
                </div>
                <div className="text-center p-3 col-12 col-sm-6 col-md-4 col-lg-2">
                    <span>Valor de Custas</span>
                    <strong className="w-100 d-block font-size-lg">
                        {formatMoneyReais(indicadores.VL_CUSTAS)}
                    </strong>
                </div>
                <div className="text-center p-3 col-12 col-sm-6 col-md-4 col-lg-2">
                    <span>Valor do Seguro</span>
                    <strong className="w-100 d-block font-size-lg">
                        {formatMoneyReais(indicadores.VL_SEGURO)}
                    </strong>
                </div>
                <div className="text-center p-3 col-12 col-sm-6 col-md-4 col-lg-2">
                    <span>Valor Honorário</span>
                    <strong className="w-100 d-block font-size-lg">
                        {formatMoneyReais(indicadores.VL_HONORARIO)}
                    </strong>
                </div>
                <div className="text-center p-3 col-12 col-sm-6 col-md-4 col-lg-2">
                    <span>Valor Desconto</span>
                    <strong className="w-100 d-block font-size-lg">
                        {formatMoneyReais(indicadores.VL_DESCONTO)}
                    </strong>
                </div>
                <div className="text-center p-3 col-12 col-sm-6 col-md-4 col-lg-2">
                    <span>Valor Total</span>
                    <strong className="w-100 d-block font-size-lg">
                        {formatMoneyReais(indicadores.VL_TOTAL)}
                    </strong>
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
}
